import { useCallback, useEffect } from "react";
import { combineFlags, trackFlags } from "../flags";
import { useAppDispatch, useAppSelector } from "./store";
import _ from "lodash";
import { useCookies } from "react-cookie";
import { ALL_FLAGS, Flags } from "../../reducers/models/flags";
import { setFlags } from "../../reducers/flags";
import { updateUserAttributes } from "aws-amplify/auth";
import { useLoadAuth } from "./auth";

export default function useSyncFlags() {
  const dispatch = useAppDispatch();
  const loadAuth = useLoadAuth();
  const [cookies] = useCookies(ALL_FLAGS, { doNotParse: true });
  const { flags } = useAppSelector((state) => state.flags);
  const { flags: flagsFromAttributes, signedIn } = useAppSelector(
    (state) => state.auth,
  );

  const updateFlagsInCognito = useCallback(
    async (combinedFlags: Flags) => {
      await updateUserAttributes({
        userAttributes: {
          "custom:flags": JSON.stringify(combinedFlags),
        },
      });
      void loadAuth();
    },
    [loadAuth],
  );

  useEffect(() => {
    const combinedFlags = combineFlags(cookies, flagsFromAttributes);
    if (!_.isEqual(flags, combinedFlags)) {
      dispatch(setFlags({ flags: combinedFlags }));
      trackFlags(combinedFlags);
    }
  }, [cookies, dispatch, flags, flagsFromAttributes]);

  useEffect(() => {
    const combinedFlags = combineFlags(cookies, flagsFromAttributes);
    if (signedIn && !_.isEqual(combinedFlags, flagsFromAttributes)) {
      void updateFlagsInCognito(combinedFlags);
    }
  }, [cookies, flagsFromAttributes, signedIn, updateFlagsInCognito]);
}
